<div class="flex">
  <sbnb-subnav [header]="'OPERATIONS.OPERATIONS' | transloco">
    <sbnb-operations-subnav></sbnb-operations-subnav>
    <sbnb-helptext-wrapper [area]="'sidebar'" [pageId]="'statements-property'"></sbnb-helptext-wrapper>
  </sbnb-subnav>

  <main class="subnav__exists flex-1" [ngClass.lt-md]="{ mobile: true, subnav__exists: false }">
    <div class="w-full relative" *ngIf="data$ | async as data">
      <app-feature-flag-tabs>
        <sbnb-page-header navTabs>
          <div class="flex items-center gap-2 sbnbDesktop:pb-4 sbnbDesktop:mb-8">
            <sbnb-back-button [iconOnly]="true"></sbnb-back-button>
            <h2 class="flex-1 mb-0">{{ data.name }}</h2>
          </div>
        </sbnb-page-header>
        <div class="flex items-center gap-2 pb-4 mb-8">
          <sbnb-back-button [iconOnly]="true"></sbnb-back-button>
          <h2 class="flex-1 mb-0">{{ data.name }}</h2>
        </div>
      </app-feature-flag-tabs>
    </div>

    <div class="flex flex-col gap-8" *ngIf="data$ | async as data">
      <div class="flex flex-col gap-3">
        <h3>Owner</h3>
        <div *ngIf="closedStatements$ | async as closedStatements" class="text__small text-night">
          {{
            closedStatements?.length
              ? 'Properties with closed statments cannot change owners.'
              : 'Adding or changing an owner will regenerate all open statements for this property.'
          }}
        </div>
        <sbnb-alert-card *ngIf="!data?.owners?.length" context="warning" class="flex gap-2 items-center">
          <sbnb-icon [size]="16" icon="alert-triangle" class="text-lemon-darker"></sbnb-icon>
          <span>This property has no owner. Create or assign an owner to generate statements.</span>
        </sbnb-alert-card>
        <div class="flex gap-4 items-center">
          <mat-form-field class="nopadding">
            <sbnb-dropdown
              [options]="owners$ | async"
              [formControl]="ownerCtrl"
              placeholder="Select owner"
              [actionOption]="true">
              <button type="button" class="link" (click)="openNewOwnerDialog()">+ Create new owner</button>
            </sbnb-dropdown>
          </mat-form-field>
          <sbnb-button
            *ngIf="ownerCtrl.touched && ownerCtrl.value"
            [loading]="savingOwner$ | async"
            loadingLabel="Updating owner..."
            size="mini"
            label="Change owner"
            (click)="changeOwner()"></sbnb-button>
        </div>
      </div>

      <!-- Commissions -->
      <div class="flex flex-col gap-3">
        <div class="flex justify-between items-center">
          <h3>Reservation Agreements</h3>
          <sbnb-button
            *ngIf="(addingCommissionPeriod$ | async) === false && (availableCommissions$ | async)?.length > 0"
            [disabled]="(availableCommissions$ | async)?.length < 1"
            [matTooltip]="(availableCommissions$ | async)?.length < 1 ? 'No additional agreements available' : ''"
            size="mini"
            label="+ Add Agreement Period"
            (click)="addCommissionPeriod()"></sbnb-button>
        </div>

        <table mat-table class="w-full min-w-[720px]" [dataSource]="commissionsDataSource$ | async">
          <!-- Name -->
          <ng-container matColumnDef="name">
            <th mat-header-cell *matHeaderCellDef>Agreement</th>
            <td mat-cell *matCellDef="let element">
              <!-- Edit-->
              <ng-container *ngIf="!element?.id; else name">
                <!-- Select commission -->
                <mat-form-field
                  [formGroup]="newCommissionPeriodForm"
                  class="input__mini nomargin nopadding"
                  *ngIf="availableCommissions$ | async as commissions">
                  <mat-label>Select agreement</mat-label>
                  <sbnb-dropdown
                    [options]="commissions"
                    formControlName="id"
                    placeholder="Select agreement"
                    [actionOption]="true">
                    <button type="button" class="link" (click)="openNewAgreementDialog()">
                      + Create new agreement
                    </button>
                  </sbnb-dropdown>
                  <mat-error>Commission is required</mat-error>
                </mat-form-field>
              </ng-container>
              <!-- Readonly -->
              <ng-template #name>
                <a class="link" [href]="'/operations/statements/commissions/' + element.id">
                  {{ element?.name ?? 'Reservation commission 1' }}
                </a>
              </ng-template>
            </td>
          </ng-container>

          <!-- Starts at -->
          <ng-container matColumnDef="startsAt">
            <th mat-header-cell *matHeaderCellDef>Starts</th>
            <td mat-cell *matCellDef="let element">
              <ng-container *ngIf="!element?.id; else startsAt">
                <!-- Select start date -->
                <mat-form-field
                  [formGroup]="newCommissionPeriodForm"
                  class="input__mini nomargin nopadding"
                  *ngIf="startsAtOptions$ | async as startsAtOptions">
                  <mat-select formControlName="startsAt" placeholder="Select starts at">
                    <mat-option *ngFor="let option of startsAtOptions" [value]="option.value">
                      {{ option.label | date: 'mediumDate' }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </ng-container>
              <!-- Readonly -->
              <ng-template #startsAt>
                {{ element?.starts_at | date: 'mediumDate' }}
              </ng-template>
            </td>
          </ng-container>

          <!-- Expires at -->
          <ng-container matColumnDef="endsAt">
            <th mat-header-cell *matHeaderCellDef>Expires</th>
            <td mat-cell *matCellDef="let element">
              <!-- If its a real commission period and it doesn't have an expiration, when the new
               period form is active, the expiration date becomes the new starts at -->
              {{
                element.id && !element.ends_at && newCommissionPeriodForm.get('startsAt').value
                  ? (newCommissionPeriodForm.get('startsAt').value | date: 'mediumDate')
                  : ((element.ends_at | date: 'mediumDate') ?? '—')
              }}
            </td>
          </ng-container>

          <!-- Actions -->
          <ng-container matColumnDef="actions">
            <th mat-header-cell *matHeaderCellDef></th>
            <td mat-cell *matCellDef="let element">
              <div class="flex items-center justify-center gap-3" *ngIf="!element?.id">
                <!-- Save -->
                <sbnb-button
                  [loading]="savingCommissionPeriod$ | async"
                  [disabled]="newCommissionPeriodForm.invalid"
                  loadingLabel="Saving"
                  size="mini"
                  type="primary"
                  label="Save"
                  (click)="saveCommissionPeriod()"></sbnb-button>

                <!-- Close -->
                <div class="flex items-center"><sbnb-close (click)="cancelAddCommissionPeriod()"></sbnb-close></div>
              </div>
              <div class="flex items-center justify-center gap-3" *ngIf="element?.id">
                <!-- Delete -->
                <sbnb-button
                  *ngIf="element?.actions.includes(agreementActionEnum.Delete)"
                  type="secondary"
                  size="mini"
                  matTooltip="Delete this agreement period"
                  [disabled]="savingCommissionPeriod$ | async"
                  (click)="deletePropertyCommissionRate(element.id)">
                  <sbnb-icon icon="trash"></sbnb-icon>
                </sbnb-button>
              </div>
            </td>
          </ng-container>

          <!-- Row definition -->
          <tr mat-header-row *matHeaderRowDef="commissionColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: commissionColumns"></tr>
        </table>
      </div>

      <!-- Statements -->
      <div class="flex flex-col gap-3">
        <h3>Statements</h3>

        <sbnb-statement-tabs></sbnb-statement-tabs>
      </div>
    </div>
  </main>
</div>

<sbnb-mobile-sidebar [navTabsHide]="true" [title]="'Operations'">
  <sbnb-operations-subnav></sbnb-operations-subnav>
</sbnb-mobile-sidebar>
